<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
              <p class="textcenter"> {{year}} © AutomatR. Version: {{version}}</p>
            </div>
        </div>
    </div>
</footer>